import { useMemo, useState } from "react";
import PanelSidebar from "./components/PanelSidebar";
import { AdminProvider } from "@/store/AdminContext";
import OverviewSection from "./sections/OverviewSection";
import SiteSheetSection from "./sections/SiteSheetSection";
import EditSiteSection from "./sections/EditSiteSection";
import CategoriesSection from "./sections/CategoriesSection";
import CatalogSection from "./sections/CatalogSection";
import CustomersSection from "./sections/CustomersSection";
import OrdersSection from "./sections/OrdersSection";
import DeliverySection from "./sections/DeliverySection";
import WhatsAppSection from "./sections/WhatsAppSection";
import SettingsSection from "./sections/SettingsSection";
import SeoSection from "./sections/SeoSection";
import HistorySection from "./sections/HistorySection";
import { PANEL_MENU } from "@/mocks/panelContent";
import type { PanelSectionId } from "./types";

function PanelShell() {
  const [active, setActive] = useState<PanelSectionId>("visao-geral");
  const [mobileOpen, setMobileOpen] = useState(false);

  const activeLabel = useMemo(
    () => PANEL_MENU.find((item) => item.id === active)?.label ?? "Painel",
    [active],
  );

  const renderSection = () => {
    switch (active) {
      case "visao-geral":
        return <OverviewSection onGoTo={setActive} />;
      case "ficha":
        return <SiteSheetSection />;
      case "editar-site":
        return <EditSiteSection />;
      case "categorias":
        return <CategoriesSection />;
      case "catalogo":
        return <CatalogSection />;
      case "clientes":
        return <CustomersSection />;
      case "pedidos":
        return <OrdersSection />;
      case "entregas":
        return <DeliverySection />;
      case "whatsapp":
        return <WhatsAppSection />;
      case "configuracoes":
        return <SettingsSection />;
      case "seo":
        return <SeoSection />;
      case "historico":
        return <HistorySection />;
      default:
        return null;
    }
  };

  return (
    <div className="flex min-h-screen w-full bg-background-100">
      <PanelSidebar
        active={active}
        onSelect={setActive}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="sticky top-0 z-40 flex items-center gap-3 border-b border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur md:px-6">
          <button
            type="button"
            onClick={() => setMobileOpen(true)}
            aria-label="Abrir menu do painel"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 lg:hidden"
          >
            <i className="ri-menu-line text-xl" />
          </button>

          <div className="min-w-0 flex-1">
            <h1 className="truncate font-heading text-xl text-foreground-900 md:text-2xl">
              {activeLabel}
            </h1>
            <p className="hidden text-[11px] text-foreground-500 sm:block">
              Painel Amora Belle · modelo demonstrativo da Vellora Studio
            </p>
          </div>

          <span className="hidden items-center gap-2 rounded-full border border-secondary-300 bg-secondary-50 px-3 py-1.5 text-[11px] text-foreground-700 md:inline-flex">
            <i className="ri-eye-line text-sm text-secondary-700" />
            Demonstração local
          </span>
        </header>

        <main className="flex-1 px-4 py-6 md:px-6 md:py-8">
          <div className="mx-auto w-full max-w-6xl">{renderSection()}</div>
        </main>
      </div>

    </div>
  );
}

export default function PainelPage() {
  return (
    <AdminProvider>
      <PanelShell />
    </AdminProvider>
  );
}
